import { InboxActions } from '@store/reducers/inbox'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

// Both lists are asked for when the page opens or the workspace changes;
// one clock for the whole list, taken at that moment
export const useActivityPage = (workspace: string): number => {
  const dispatch = useDispatch()
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    if (!workspace) {
      return
    }

    setNow(Date.now())
    dispatch(InboxActions.fetchFresh({ workspace }))
    dispatch(InboxActions.fetchEarlier({ workspace, before: null }))
  }, [workspace])

  return now
}
